module.exports = __webpack_public_path__ + "static/media/tc.a260af55.png";